import React, { Component } from "react";
import "./epfdashboard.css";
import { t } from "i18next";
import {
  BreadCrumb,
  Button,
  CardDetailContainer,
  Header,
  TitleView,
  SideModel,
  Toast,
  ProgressDialog,
} from "../../components";
import * as Bl from "../../../businesslogic";
import { getFinancialNonMarketPath, getUserId } from "../../common";
import { INVESTMENT_CATEGORY } from "../../constants";
import { getFormatAmount } from "../../common";
import * as logger from "../../utils/logger/index";

class EPFDashBoard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showEditView: false,
      showModal: false,
      investmentData: [],
    };
    this.isRenderingAlready = false;
  }

  componentDidMount() {
    if (!this.isRenderingAlready) {
      this.isRenderingAlready = true;
      this.getUserInvestmentByCategory();
    }
  }

  onSelectItem(path) {
    this.props.navigate(path);
  }

  onClickMoreIcon() {
    this.setState({ showEditView: !this.state.showEditView });
  }

  onClickEditIcon = (selectedItem) => {
    this.props.navigate("/epfdetails", {
      state: { investmentData: selectedItem.item, isEditView: true },
    });
  };

  onPressAddMoreView() {
    this.props.navigate("/epfhome");
  }

  onPressSaveButton() {
    this.props.navigate("/financialdetails");
  }

  onClickCancel() {
    this.setState({ showModal: false });
  }

  onPressNo() {
    this.setState({ showModal: false });
  }

  onPressYes(selectedItem) {
    this.deleteInvestment(selectedItem.item);
  }

  hideToast() {
    this.setState({ toastMessage: "", showToast: false });
  }

  showToast(toastMessage) {
    this.setState(
      { toastMessage, showToast: true, showProgress: false },
      () => {
        setTimeout(() => {
          this.hideToast();
        }, 3000);
      }
    );
  }
  getTotalBalance(list) {
    const totalArray = [];
    list.forEach((item) => {
      totalArray.push({
        money: item.currentvalue,
      });
    });
    const total = totalArray.reduce((a, v) => (a = a + v.money), 0);
    return total;
  }
  prepareCardData(list) {
    const displayData = [];
    list.forEach((item) => {
      displayData.push({
        title: "EPF",
        currencyLabel: "Current Value",
        money: item.currentvalue,
        extraContent: item?.fvatretirement ? `Maturity Value  :  ₹ ${getFormatAmount(item.fvatretirement)} | ${item.maturityyear}` : "",
        item,
      });
    });
    return displayData;
  }
  getUserInvestmentByCategory() {
    const data = {
      uuid: getUserId(),
      category: INVESTMENT_CATEGORY.EPF,
    };

    this.setState({ showProgress: true }, () => {
      Bl.Investment.getUserInvestmentByCategory(data)
        .then((list) => {
          this.setState({ showProgress: false, investmentData: list });
        })
        .catch((error) => {
          logger.error({ error })
          this.showToast(t("someErrorHasOccured"));
        });
    });
  }

  deleteInvestment(item) {
    const investmentObj = new Bl.Investment(item);
    this.setState({ showProgress: true }, () => {
      investmentObj
        .deleteInvestment()
        .then(() => {
          const newList =
            this.state.investmentData &&
            this.state.investmentData.filter((e) => e.id !== item.id);
          this.setState({ investmentData: newList, showProgress: false });
        })
        .catch((error) => {
          logger.error({ error })
          this.showToast(t("someErrorHasOccured"));
        });
    });
  }


  renderNavView() {
    const items = getFinancialNonMarketPath("EPF");
    const location = this.props.location;
    return (
      <BreadCrumb
        items={items}
        isLastPath={true}
        currentPath={location.pathname}
        onClickBackIcon={this.onSelectItem.bind(this)}
        onClickItem={this.onSelectItem.bind(this)}
      />
    );
  }

  renderTitleView() {
    const title = t("networthAssetsFNM4");
    return <TitleView title={title} information={''} />;
  }

  renderExpectedValueView() {
    const totalBalance = this.getTotalBalance(this.state.investmentData);
    const displayAmount = getFormatAmount(totalBalance);
    return (
      <div className="edb_expect_value_view">
        <label className="edb_value_text">
          {t("epfDBValue")}: ₹ {displayAmount}
        </label>
      </div>
    );
  }

  renderCardView() {
    const cardData = this.prepareCardData(this.state.investmentData);
    return (
      <div className="edb_card_view">
        {cardData.map((card, index) => (
          <CardDetailContainer
            key={index}
            title={card.title}
            currentValue={card.currencyLabel}
            money={card.money}
            extraContent={card.extraContent}
            onClickEdit={() => this.onClickEditIcon(card)}
            onPressNo={this.onPressNo.bind(this)}
            onPressYes={() => this.onPressYes(card)}
          />
        ))}
      </div>
    );
  }

  renderButtonsView() {
    return (
      <div className="edb_bottomView">
        <div className="edb_buttonView">
          <div className="edb_addmore_button">
            <Button
              buttonName={t("epfDBButton1")}
              emptyButton={true}
              onPressButton={this.onPressAddMoreView.bind(this)}
            />
          </div>
          <div className="edb_save">
            <Button
              buttonName={t("epfDBButton2")}
              onPressButton={this.onPressSaveButton.bind(this)}
            />
          </div>
        </div>
      </div>
    );
  }

  renderContentView() {
    return (
      <div className="edb_content_view">
        {this.renderTitleView()}
        {this.renderExpectedValueView()}
        {this.renderCardView()}
      </div>
    );
  }
  renderToastView() {
    return (
      <Toast
        showToast={this.state.showToast}
        toastMessage={this.state.toastMessage}
      />
    );
  }

  renderProgressDialog() {
    return (
      <ProgressDialog
        showProgress={this.state.showProgress}
        progressMessage={this.state.progressMessage}
      />
    );
  }
  renderDrawerContent() {
    const headerTitle = t("financialPlan");
    const step = 1;
    return <SideModel step={step} headerTitle={headerTitle}></SideModel>;
  }
  render() {
    return (
      <div className="edb_container">
        {this.renderNavView()}
        {this.renderContentView()}
        {this.renderButtonsView()}
        {/* {this.renderDrawerContent()} */}
        {this.renderToastView()}
        {this.renderProgressDialog()}
      </div>
    );
  }
}

export default EPFDashBoard;
